import {
  Home,
  MapPin,
  Map,
  Navigation,
  Globe,
} from "lucide-react";

import "./ProviderCards.css";

function AddressCard({ provider }) {

  const address = provider.address || {};

  const addressDetails = [

    {
      icon: <Home size={18} />,
      label: "Door No",
      value: address.doorNo || "-",
    },

    {
      icon: <Navigation size={18} />,
      label: "Street",
      value: address.street || "-",
    },

    {
      icon: <Map size={18} />,
      label: "Area",
      value: address.area || "-",
    },

    {
      icon: <MapPin size={18} />,
      label: "City",
      value: address.city || "-",
    },

    {
      icon: <Globe size={18} />,
      label: "State",
      value: address.state || "-",
    },

    {
      icon: <MapPin size={18} />,
      label: "Pincode",
      value: address.pincode || "-",
    },

  ];

  const fullAddress = [

    address.doorNo,
    address.street,
    address.landmark,
    address.area,
    address.city,
    address.state,
    address.pincode,

  ]
    .filter(Boolean)
    .join(", ");

  return (

    <div className="provider-card">

      <h3 className="card-title">

        Address Information

      </h3>

      <div className="info-list">

        {addressDetails.map((item, index) => (

          <div
            className="info-row"
            key={index}
          >

            <div className="info-label">

              {item.icon}

              <span>

                {item.label}

              </span>

            </div>

            <div className="info-value">

              {item.value}

            </div>

          </div>

        ))}

      </div>

      <div className="address-preview">

        <h4>

          Complete Address

        </h4>

        <p>

          {fullAddress || "No address available"}

        </p>

      </div>

    </div>

  );

}

export default AddressCard;